// Generated by scripts/generate-build-info.js — do not edit.
export default {
  "version": "1.0.1",
  "tag": "v1.0.1",
  "sha": "04fd9d2",
  "branch": "master",
  "dirty": true,
  "repo": "https://gitlab.ufpe.br/thiago.prazeres/design-system-portal-ru3",
  "commitUrl": "https://gitlab.ufpe.br/thiago.prazeres/design-system-portal-ru3/-/commit/04fd9d2",
  "tagUrl": "https://gitlab.ufpe.br/thiago.prazeres/design-system-portal-ru3/-/tags/v1.0.1",
  "builtAt": "2026-05-18T07:11:00.260Z"
};
